import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["width", "minWidth", "nameConfigHandler", "noFlexGrow"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from '@jd/jmtd-tools/es/classnames';
import React from 'react';
import { getObjectValue, getValue } from '../tools/util';
import Label from '../Label';
import ConfigConsumer from '../ConfigConsumer';
export default function TableFormatterName(_ref) {
  var width = _ref.width,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 270 : _ref$minWidth,
      nameConfigHandler = _ref.nameConfigHandler,
      noFlexGrow = _ref.noFlexGrow,
      args = _objectWithoutProperties(_ref, _excluded);

  return {
    width: width,
    flexGrow: width || noFlexGrow ? undefined : minWidth,
    monoSpaced: true,
    render: function render(text, row) {
      var _args$getValue = _objectSpread(_objectSpread({}, args), getValue(nameConfigHandler, row, args)),
          tooltipTheme = _args$getValue.tooltipTheme,
          textIndex = _args$getValue.textIndex,
          imgIndex = _args$getValue.imgIndex,
          urlIndex = _args$getValue.urlIndex,
          descriptionLabel = _args$getValue.descriptionLabel,
          _args$getValue$idLabe = _args$getValue.idLabel,
          idLabel = _args$getValue$idLabe === void 0 ? descriptionLabel : _args$getValue$idLabe,
          _args$getValue$textTi = _args$getValue.textTitle,
          textTitle = _args$getValue$textTi === void 0 ? function () {
        return null;
      } : _args$getValue$textTi,
          _args$getValue$descri = _args$getValue.descriptionTitle,
          descriptionTitle = _args$getValue$descri === void 0 ? function () {
        return null;
      } : _args$getValue$descri,
          _args$getValue$idTitl = _args$getValue.idTitle,
          idTitle = _args$getValue$idTitl === void 0 ? descriptionTitle : _args$getValue$idTitl,
          descriptionIndex = _args$getValue.descriptionIndex,
          _args$getValue$idInde = _args$getValue.idIndex,
          idIndex = _args$getValue$idInde === void 0 ? descriptionIndex : _args$getValue$idInde,
          _args$getValue$placeh = _args$getValue.placeholder,
          placeholder = _args$getValue$placeh === void 0 ? '- -' : _args$getValue$placeh,
          _args$getValue$descri2 = _args$getValue.descriptionPlaceholder,
          descriptionPlaceholder = _args$getValue$descri2 === void 0 ? placeholder : _args$getValue$descri2,
          _args$getValue$idPlac = _args$getValue.idPlaceholder,
          idPlaceholder = _args$getValue$idPlac === void 0 ? descriptionPlaceholder : _args$getValue$idPlac,
          fallbackImg = _args$getValue.fallbackImg,
          _args$getValue$isEmpt = _args$getValue.isEmpty,
          isEmpty = _args$getValue$isEmpt === void 0 ? function () {
        return false;
      } : _args$getValue$isEmpt;

      var get = function get(key) {
        return key ? getObjectValue(row, key) : '';
      };

      var url = urlIndex ? get(urlIndex) : null;
      var mainContent = textIndex ? get(textIndex) : text;

      if (isEmpty(text, row)) {
        return placeholder;
      }

      function getIdLabel() {
        var result = getValue(idLabel, row);
        return result ? "".concat(result, "\uFF1A") : '';
      }

      var image = /*#__PURE__*/React.createElement("img", {
        className: "jmtd-table-formatter-name-img",
        src: get(imgIndex),
        alt: "",
        onError: function onError(e) {
          if (fallbackImg) {
            e.target.src = fallbackImg;
          } else {
            e.target.parentElement.classList.add('jmtd-table-formatter-name-img-wrapper-fallback');
          }
        }
      });
      return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
        var size = _ref2.size,
            _ref2$tableFormatterN = _ref2.tableFormatterNameTooltipTheme,
            tableFormatterNameTooltipTheme = _ref2$tableFormatterN === void 0 ? 'light' : _ref2$tableFormatterN;
        var labelTheme = tooltipTheme || tableFormatterNameTooltipTheme;
        var name = /*#__PURE__*/React.createElement(Label, {
          theme: labelTheme,
          title: get(textTitle)
        }, mainContent !== null && mainContent !== void 0 ? mainContent : placeholder);
        return /*#__PURE__*/React.createElement("div", {
          className: classNames('jmtd-table-formatter-name', {
            'jmtd-table-formatter-name-with-image': imgIndex,
            'jmtd-table-formatter-name-small': size === 'small' || size === 'mini'
          })
        }, imgIndex && (url ? /*#__PURE__*/React.createElement("a", {
          className: "jmtd-table-formatter-name-img-wrapper",
          href: url,
          rel: "noopener noreferrer",
          target: "_blank"
        }, image) : /*#__PURE__*/React.createElement("div", {
          className: "jmtd-table-formatter-name-img-wrapper"
        }, image)), /*#__PURE__*/React.createElement("div", {
          className: "jmtd-table-formatter-name-main"
        }, /*#__PURE__*/React.createElement("div", {
          className: "jmtd-table-formatter-name-name"
        }, url ? /*#__PURE__*/React.createElement("a", {
          className: "jmtd-table-formatter-name-link",
          href: url,
          rel: "noopener noreferrer",
          target: "_blank"
        }, name) : name), idLabel && /*#__PURE__*/React.createElement(Label, {
          theme: labelTheme,
          title: get(idTitle),
          className: "jmtd-table-formatter-name-desc"
        }, getIdLabel(), get(idIndex) || idPlaceholder)));
      });
    }
  };
}